export default __webpack_public_path__ + "static/media/image-12.ad2bec85.gif";